export default (t) => [
  {
    text: t('Product / Inventory'),
    value: 'name'
  },
  {
    text: t('Quantity'),
    value: 'quantity'
  },
  {
    text: t('Unit'),
    value: 'unit'
  },
  {
    text: t('Shelf Life'),
    value: 'shelf_life_value'
  },
  {
    text: t('Cost Alloc.') + ' (%)',
    value: 'cost_allocation_percent'
  }
];
